const RugTablesBlu = Object.freeze({
  CREDIT: 'CREDIT',
  GUARANTEE: 'GUARANTEE',
  CLIENT: 'CLIENT',
  RUG_GRANTOR: 'RUG_GRANTOR',
  COMPETITOR: 'COMPETITOR',
  SAT_TAXPAYER: 'SAT_TAXPAYER'
})

module.exports = RugTablesBlu
